import { CodeListItemWire } from '../../common';
import { CodeListItem } from '../types-store';
import { parseAsDateUTC } from 'app/infrastructure/data/date';

export const mapListToStore = (codeItems: CodeListItemWire[]): CodeListItem[] => {

  return codeItems && codeItems
    .map(item => ({

      id: item.code && item.code.v,
      description: item.code && item.code.d,
      disabled: parseAsDateUTC(item.disabled),

      userGroups: [],
      excludedFields: [],
      caseTypes: [],

      childrenCount: item.descendantCount || 0,
      deletingCodeItem: false,

      colour: item.decimalColour,
      icon: item.icon,

      level: item.level,
      sequence: item.sequence,

      ...(!!item.category && {
        category: {
          value: item.category.v,
          description: item.category.d,
          ...(!!item.category?.disabled) && {
            disabled: parseAsDateUTC(item.category.disabled)
          }
        }
      }),
      ...(!!item.severity && {
        severity: {
          value: item.severity.v,
          description: item.severity.d
        }
      }),
      ...(!!item.likelihood && {
        likelihood: {
          value: item.likelihood.v,
          description: item.likelihood.d
        }
      }),
      ...(!!item.recurrence && {
        recurrence: {
          value: item.recurrence.v,
          description: item.recurrence.d
        }
      }),
      ...(!!item.node && {
        node: {
          value: item.node.v,
          description: item.node.d,
          longDescription: item.node?.ld,
          disabled: parseAsDateUTC(item.node.disabled)
        }
      }),
      ...(!!item.parent && {
        parent: {
          value: item.parent.v,
          description: item.parent.d
        }
      })
    })) || [] as CodeListItem[];
};
